import { UserAgreementAcceptGaurd } from './service/common/user-agreement-acceptguard.service';
import { WindowRefService } from './service/common/window.ref.service';
import { HttpClient } from './common/HttpClient';
import { SharedService } from './service/common/shared.service';
import { MainPageService } from './main-page/main-page.service';
import { SessionStorageService } from './service/common/session-storage.service';
import { AppStorageService } from './service/common/app-storage.service';
import { AuthService } from './service/common/auth.service';
import { UserService } from './service/common/user.service';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpModule, Http } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppComponent } from './dbm.data.store.component';
import { LogoutComponent } from './logout.component';
import { MainPageModule } from './main-page/main-page.module';
import { TranslatePipe } from '@ngx-translate/core';
import { RootComponent } from './root/root.component';
import { RouteGuard } from './service/common/routeguard.service';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { OauthcallbackComponent } from './oauthcallback/oauthcallback.component';
import { ToasterModule } from 'angular2-toaster';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NavService } from './service/common/nav.service';
import {HelpersService} from './service/common/helpers.service';
import {ConnectionPanelsHelperService} from './service/common/connection-panels-helper.service';
import {API_URL} from './service/common/helpers.service';
import {IMAGE_URL} from './service/common/helpers.service';
import {environment} from './environments/environment';
import {CacheService, CacheStorageAbstract, CacheMemoryStorage} from 'ng2-cache';
import { UserRoleService } from './service/common/user-role.service';
import { DownloadHelperService } from './service/common/download-helper.service';
import { CrowdinService } from './service/common/crowdin.service';
import { CommonService } from './service/common/common.service';
import { CarinaUIModule} from '@hilti/carina-ui';
import { appRoutes} from './dbm.data.store.routing';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './shared/navigation/navigation.component';
import { StpConfigureService } from './main-page/stp-configure/stp-configure.service';

@NgModule({
  declarations: [
   AppComponent,
    LogoutComponent,
    RootComponent,
    OauthcallbackComponent,
    NavigationComponent
  ],
  imports: [
    CommonModule,
    HttpModule,
    ToasterModule,
    MainPageModule,
    CarinaUIModule,
    NgbModule.forRoot(),
    RouterModule.forChild(appRoutes),
  ],
  providers: [UserService,
    UserRoleService,
    AuthService,
    SessionStorageService,
    AppStorageService,
    SharedService,
    MainPageService,
    StpConfigureService,
    HttpClient,
    RouteGuard,
    UserAgreementAcceptGaurd,
    WindowRefService,
    HelpersService,
    ConnectionPanelsHelperService,
    NavService,
    DownloadHelperService,
    CrowdinService,
    CommonService,
    { provide: CacheStorageAbstract, useClass: CacheMemoryStorage },
    CacheService,
    { provide: API_URL, useValue: environment.api_url },
    { provide: IMAGE_URL, useValue: environment.imageUrl },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DBMDataStoreModule { 
  public static forRoot(environment: any) {
    return {
      ngModule: DBMDataStoreModule
    };
}
}